import { slide as Menu } from 'react-burger-menu';
import { NavLink } from 'react-router-dom';
import React from 'react';

const BurgerMenu = () => {
  const styles = {
    bmBurgerButton: {
      position: 'fixed',
      width: '36px',
      height: '30px',
      right: '36px',
      top: '25px',
    },
    bmBurgerBars: {
      background: 'white',
      opacity: 0.8,
    },
    bmBurgerBarsHover: {
    },
    bmCrossButton: {
      height: '24px',
      width: '24px',
    },
    bmCross: {
      background: '#bdc3c7',
    },
    bmMenuWrap: {
      position: 'fixed',
    },
    bmMenu: {
      textDecoration: 'none',
      background: '#2A2A2AFF',
      padding: '2.5em 1.5em 0',
      fontFamily: 'Br-cobane-font',
      fontSize: '1em',
      color: 'white',
    },
    bmItemList: {
      padding: '0.8em',
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
    },
    bmItem: {
      color: 'white',
      display: 'inline-block',
      margin: '10px 0',
    },
    bmOverlay: {
      background: 'rgba(0, 0, 0, 0.3)',
    },
  };

  return (
    <Menu className="burger-menu" styles={styles} noOverlay right disableAutoFocus isOpen={false}>
      <NavLink activeclassname="active" to="/research">RESEARCH</NavLink>
      <NavLink activeclassname="active" to="/source">RESOURCES</NavLink>
      <NavLink activeclassname="active" to="/publications">PUBLICATIONS</NavLink>
      <NavLink activeclassname="active" to="/news">NEWS</NavLink>
      <NavLink activeclassname="active" to="/group">GROUP</NavLink>
      <NavLink activeclassname="active" to="/contact">CONTACT</NavLink>
    </Menu>
  );
};

export default BurgerMenu;
